export const BOARD_ID = 'board'

export const SQUARE = 'square'
export const WHITE = 'white'
export const BLACK = 'black'

export const SQUARE_CLASS = `.${SQUARE}-55d63`
export const BLACK_SQUARE_CLASS = `${BLACK}-3c85d`
export const MOVE_DEST = 'move-dest'
